import { doDefaultFetch } from '@nhl/fetch-helpers';

const recordDetailsEndpoint = (recordCategoryKey, recordTypeKey) => {
    const recordTypeExp = recordTypeKey ? ` and recordType.descriptionKey='${recordTypeKey}'` : '';
    return (
        `${window.recordsSettings.franchiseScopedRestUrl}/record-detail` +
        `?cayenneExp=recordCategory.short_description="${recordCategoryKey}"` +
        recordTypeExp +
        `&include=recordCategory.id` +
        `&include=recordType.id` +
        `&include=recordToFranchise`
    );
};

const searchRecordsData = (query) => {
    return doDefaultFetch(
        `${window.recordsSettings.franchiseScopedRestUrl}/record-detail` +
            `?cayenneExp=${query.split(/\s|,/).reduce((acc, q) => {
                // This breaks out the search parameter into individual chunks. We instruct AgRest to match
                // where the description is like each individual chunk, eg if the search term was 'rookie goals'
                // the record's description must have both rookie and goals in it
                if (acc !== '') {
                    acc += ` and `;
                }
                acc += `description likeIgnoreCase '%${q}%'`;

                return acc;
            }, '')}` +
            `&include=["recordCategory","recordType","recordToFranchise"]` +
            `&sort=[{"property":"recordType.sequence"},{"property":"recordToFranchise.sequence"}]` +
            `&start=0&limit=20`,
        { isPublic: true }
    );
};

export default {
    recordDetailsEndpoint,
    searchRecordsData,
};
